/* ==========================================================================
   WRIP — theme behaviour
   Ports the interaction model from the "WRIP Shop" Claude Design canvas onto
   Shopify's AJAX cart. Deliberately dependency-free and in one file: the theme
   is small, and splitting cart/product/ui created load-order coupling for no
   benefit.
   ========================================================================== */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = (window.WRIP && window.WRIP.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    // Shopify money formats use {{amount}}, {{amount_no_decimals}}, etc. We only
    // need the common two; anything else falls through to the plain amount.
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','));
  };

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var lock   = function () { document.body.classList.add('is-locked'); };
  var unlock = function () { document.body.classList.remove('is-locked'); };

  /* ── header: transparent until scrolled past 24px ──────────────────────── */

  var hdr = $('.hdr');
  if (hdr) {
    var onScroll = function () {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      hdr.classList.toggle('is-scrolled', y > 24);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── overlays (cart drawer, mobile menu, modals) ───────────────────────── */

  function openOverlay(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.hidden = false;
    lock();
    var focusable = el.querySelector('[autofocus], button, a[href], input');
    if (focusable) focusable.focus({ preventScroll: true });
  }

  function closeOverlay(el) {
    if (!el) return;
    el.hidden = true;
    if (!$$('.drawer:not([hidden]), .modal:not([hidden])').length) unlock();
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-open]');
    if (open) { e.preventDefault(); openOverlay(open.getAttribute('data-open')); return; }

    var close = e.target.closest('[data-close]');
    if (close) {
      e.preventDefault();
      closeOverlay(close.closest('.drawer, .modal') || document.getElementById(close.getAttribute('data-close')));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var top = $$('.drawer:not([hidden]), .modal:not([hidden])').pop();
    if (top) closeOverlay(top);
  });

  /* ── card hover: cross-fade through colourways ─────────────────────────────
     Two layers alternate so every fade has a stable outgoing image. A single
     layer would flicker at the moment its background-image is swapped.        */

  $$('[data-card]').forEach(function (card) {
    var shots  = JSON.parse(card.getAttribute('data-shots') || '[]');
    var layers = $$('.card__layer', card);
    var dots   = $$('.card__dot', card);
    if (shots.length < 2 || layers.length < 2) return;

    var timer = null, step = 0;

    var paint = function (i) {
      var parity = i % 2;
      var layer  = layers[parity];
      layer.style.backgroundImage = 'url("' + shots[i % shots.length] + '")';
      layers.forEach(function (l, li) { l.classList.toggle('is-on', li === parity && i > 0); });
      dots.forEach(function (d, di) { d.classList.toggle('is-on', di === i % shots.length); });
    };

    var stop = function () {
      clearInterval(timer); timer = null; step = 0;
      layers.forEach(function (l) { l.classList.remove('is-on'); });
      dots.forEach(function (d, di) { d.classList.toggle('is-on', di === 0); });
    };

    card.addEventListener('mouseenter', function () {
      clearInterval(timer);
      step = 1; paint(step);
      timer = setInterval(function () { step += 1; paint(step); }, 1700);
    });
    card.addEventListener('mouseleave', stop);

    dots.forEach(function (dot, i) {
      dot.addEventListener('mouseenter', function () {
        clearInterval(timer); timer = null;
        step = i; paint(i);
        // Re-show the base image when hovering the first dot, since layer
        // opacity is what covers it.
        if (i === 0) layers.forEach(function (l) { l.classList.remove('is-on'); });
      });
    });
  });

  /* ── product detail ────────────────────────────────────────────────────── */

  var pdp = $('[data-pdp]');
  if (pdp) {
    var variants = JSON.parse($('[data-variants]', pdp).textContent || '[]');
    // A single-variant product (the Founders Kit) has no Size axis at all, so
    // "pick a size" must not gate its buy button.
    var hasSizes   = pdp.getAttribute('data-has-sizes') === 'true';
    var isPreorder = pdp.getAttribute('data-preorder') === 'true';
    var needsTerms = pdp.getAttribute('data-requires-terms') === 'true';
    var termsAgreed = false;

    // NOT data-colour / data-size: the size pills use [data-size], and the click
    // handler resolves them with closest(). If the wrapper carried the same
    // attribute, any click inside the PDP would bubble up, match the wrapper,
    // and silently reset the chosen size to the page's initial one — a customer
    // could pick XL, click the description, and check out with an S.
    var state = {
      colour: pdp.getAttribute('data-initial-colour') || (variants[0] && variants[0].colour) || '',
      size:   pdp.getAttribute('data-initial-size')   || '',
      face:   'back',
      shot:   null      // an extra gallery image, overriding the colour's back shot
    };

    var mainEl  = $('.gallery__img', pdp);
    var altEl   = $('.gallery__alt', pdp);
    var priceEl = $('[data-price]', pdp);
    var wasEl   = $('[data-compare]', pdp);
    var ctaEl   = $('[data-add]', pdp);
    var idEl    = $('[data-variant-id]', pdp);
    var colourLabel = $('[data-colour-label]', pdp);
    var colourNote  = $('[data-colour-note]', pdp);

    var forColour = function (c) { return variants.filter(function (v) { return v.colour === c; }); };
    var match = function () {
      var group = forColour(state.colour);
      if (!hasSizes) return group[0];
      return group.filter(function (v) { return v.size === state.size; })[0];
    };

    function render() {
      var group = forColour(state.colour);
      var shot  = group[0] || {};

      // An extra shot takes over the main frame and suppresses the front overlay,
      // since Back/Front only means something for a colour's own pair.
      var mainSrc = state.shot || shot.image;
      if (mainEl) mainEl.style.backgroundImage = mainSrc ? 'url("' + mainSrc + '")' : 'none';
      if (altEl) {
        var frontSrc = state.shot ? null : shot.front;
        altEl.style.backgroundImage = frontSrc ? 'url("' + frontSrc + '")' : 'none';
        altEl.classList.toggle('has-alt', !!frontSrc);
        altEl.classList.toggle('is-on', state.face === 'front' && !!frontSrc);
      }
      $$('button[data-shot]', pdp).forEach(function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-shot') === state.shot);
      });
      // The tabs used to be hidden whenever an extra shot was showing, which
      // stranded you there: nothing but a swatch or thumbnail cleared it, so on
      // a product with a third image the Front/Back toggle simply vanished.
      // They stay visible now and double as the way back out.
      $$('[data-face]', pdp).forEach(function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-face') === state.face);
      });

      $$('[data-swatch]', pdp).forEach(function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-swatch') === state.colour);
      });
      $$('[data-thumb]', pdp).forEach(function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-thumb') === state.colour);
      });
      if (colourLabel) colourLabel.textContent = state.colour;
      if (colourNote) colourNote.textContent = shot.note || '';

      // A size is only offered if that Colour+Size combination actually exists
      // and is in stock — otherwise the picker promises variants the cart will
      // refuse.
      $$('button[data-size]', pdp).forEach(function (b) {
        var size = b.getAttribute('data-size');
        var v = group.filter(function (x) { return x.size === size; })[0];
        b.disabled = !v || !v.available;
        b.classList.toggle('is-on', size === state.size);
      });

      var v = match();
      if (priceEl) priceEl.textContent = money(v ? v.price : (shot.price || 0));
      if (wasEl) {
        var was = v ? v.compareAt : null;
        wasEl.hidden = !was;
        if (was) wasEl.textContent = money(was);
      }
      if (idEl) idEl.value = v ? v.id : '';

      if (ctaEl) {
        var ok = !!(v && v.available);
        var blocked = needsTerms && !termsAgreed;
        ctaEl.disabled = !ok || blocked;

        var label;
        if (hasSizes && !state.size) label = 'Select a size';
        else if (!ok) label = 'Sold out';
        // Deliberately NOT preorderLabel: that setting still drives the
        // "Pre-order" badges on the cards and the PDP, which is where the
        // pre-order status belongs. The button just sells.
        else label = (window.WRIP && window.WRIP.buyLabel) || 'Add to bag';
        ctaEl.textContent = label;
      }

      var hint = $('[data-terms-hint]', pdp);
      if (hint) hint.hidden = !(needsTerms && !termsAgreed);
    }

    // Exposed so the terms modal's "I agree" button can tick the box too.
    var termsEl = $('[data-terms-toggle]', pdp);
    function setAgreed(value) {
      termsAgreed = !!value;
      if (termsEl) termsEl.setAttribute('aria-checked', String(termsAgreed));
      render();
    }
    if (termsEl) {
      termsEl.addEventListener('click', function (e) {
        // "read them" opens the modal — it must not also toggle the checkbox.
        if (e.target.closest('[data-open]')) return;
        setAgreed(!termsAgreed);
      });
      termsEl.addEventListener('keydown', function (e) {
        if (e.key !== ' ' && e.key !== 'Enter') return;
        e.preventDefault();
        setAgreed(!termsAgreed);
      });
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-terms-accept]')) return;
      setAgreed(true);
      closeOverlay(document.getElementById('terms-modal'));
    });

    pdp.addEventListener('click', function (e) {
      var sw = e.target.closest('button[data-swatch]');
      if (sw) { state.colour = sw.getAttribute('data-swatch'); state.face = 'back'; state.shot = null; render(); return; }

      var th = e.target.closest('button[data-thumb]');
      if (th) { state.colour = th.getAttribute('data-thumb'); state.face = 'back'; state.shot = null; render(); return; }

      var shot = e.target.closest('button[data-shot]');
      if (shot) { state.shot = shot.getAttribute('data-shot'); state.face = 'back'; render(); return; }

      var sz = e.target.closest('button[data-size]');
      if (sz && !sz.disabled) { state.size = sz.getAttribute('data-size'); render(); return; }

      var fc = e.target.closest('button[data-face]');
      if (fc) {
        // Clearing shot is what lets Front/Back pull you out of an extra image.
        state.shot = null;
        state.face = fc.getAttribute('data-face');
        // An explicit click outranks the hover preview until the pointer
        // leaves the frame — without this the CSS :hover rule pins the front
        // shot while the cursor sits on the image and the tabs look dead.
        var frame = $('.gallery__main', pdp);
        if (frame) frame.classList.add('is-committed');
        render();
      }
    });

    // Leaving the frame re-arms the hover preview for next time.
    var frameEl = $('.gallery__main', pdp);
    if (frameEl) {
      frameEl.addEventListener('mouseleave', function () {
        frameEl.classList.remove('is-committed');
      });
    }

    render();
  }

  /* ── cart ──────────────────────────────────────────────────────────────── */

  function cartFetch(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Cart error');
        return data;
      });
    });
  }

  var preorderHandles = (window.WRIP && window.WRIP.preorderHandles) || [];

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });

    var body = $('[data-cart-body]');
    var foot = $('[data-cart-foot]');
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML =
        '<div class="empty">' +
          '<p>Nothing in the bag yet.</p>' +
          '<p>Four pieces in the first drop.</p>' +
          '<a class="btn-dark" href="/collections/the-drop">Shop the drop</a>' +
        '</div>';
      if (foot) foot.hidden = true;
      return;
    }

    body.innerHTML = cart.items.map(function (item) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      return '' +
        '<div class="line">' +
          '<div class="line__thumb" style="background-image:url(\'' + img + '\')"></div>' +
          '<div>' +
            '<h3 class="line__name">' + item.product_title + '</h3>' +
            '<p class="line__variant">' + (item.variant_title || '') +
              (preorderHandles.indexOf(item.handle) > -1 ? ' &middot; Pre-order' : '') + '</p>' +
            '<div class="line__ctrls">' +
              '<div class="qty">' +
                '<button type="button" data-qty="' + item.key + '" data-to="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-qty="' + item.key + '" data-to="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="button" class="line__remove" data-qty="' + item.key + '" data-to="0">Remove</button>' +
            '</div>' +
          '</div>' +
          '<span class="line__total">' + money(item.final_line_price) + '</span>' +
        '</div>';
    }).join('');

    if (foot) {
      foot.hidden = false;
      var sub = $('[data-subtotal]', foot);
      if (sub) sub.textContent = money(cart.total_price);
    }
  }

  function refreshCart() { return cartFetch('/cart.js').then(renderCart); }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qty]');
    if (!q) return;
    e.preventDefault();
    cartFetch('/cart/change.js', { id: q.getAttribute('data-qty'), quantity: +q.getAttribute('data-to') })
      .then(renderCart)
      .catch(function (err) { console.error('[wrip] cart change failed:', err.message); });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-form]');
    if (!form) return;
    e.preventDefault();

    var btn = $('[data-add]', form);
    var id  = $('[data-variant-id]', form);
    if (!id || !id.value) return;
    if (btn && btn.disabled) return;

    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    cartFetch('/cart/add.js', { items: [{ id: +id.value, quantity: 1 }] })
      .then(function () { return refreshCart(); })
      .then(function () { openOverlay('cart-drawer'); })
      .catch(function (err) {
        console.error('[wrip] add to cart failed:', err.message);
        if (btn) btn.textContent = err.message || 'Unavailable';
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          // Only restore the label if the catch didn't replace it with an error.
          if (btn.textContent === 'Adding…') btn.textContent = label;
        }
      });
  });

  if ($('[data-cart-body]')) refreshCart();

  /* ── founders kit request (contact form, not a product) ────────────────── */

  var kitForm = $('[data-kit-form]');
  if (kitForm) {
    kitForm.addEventListener('submit', function () {
      // Label only — do NOT disable the button. Shopify's captcha cancels this
      // submit, runs an async challenge, then re-submits the form itself; a
      // disabled submitter kills that second attempt and the form hangs on
      // "Sending…" forever. Restore the label if the challenge never returns.
      var b = $('button', kitForm);
      if (!b) return;
      var label = b.textContent;
      b.textContent = 'Sending…';
      setTimeout(function () {
        if (b.textContent === 'Sending…') b.textContent = label;
      }, 8000);
    });
  }
})();
